import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play-run-arrow",
  "use": "play-run-arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"play-run-arrow\"><path fill-rule=\"evenodd\" d=\"M8 5v14l11-7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol